import { MegaphoneIcon } from '@heroicons/react/24/outline';
import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';

const PhysicianStatusBarToggle = ({ onClick, count, className }) => {
  const cn = useClassNames(
    () => [
      'rounded-full',
      'px-2',
      'py-1',
      'bg-amber-200',
      'hover:bg-amber-400',
      'text-slate-900',
      'flex',
      'items-center',
      'leading-none',
      className,
    ],
    [className],
  );

  return (
    <button type="button" className={cn} onClick={onClick}>
      <MegaphoneIcon className="w-5" />
      {count > 0 && <span className="ml-1">{count}</span>}
    </button>
  );
};

PhysicianStatusBarToggle.propTypes = {
  onClick: PropTypes.func,
  count: PropTypes.number,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

PhysicianStatusBarToggle.defaultProps = {
  onClick: () => {},
  count: 0,
  className: [],
};

export default PhysicianStatusBarToggle;
